import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useThemeContext } from "@circle-react/providers/Theme/ThemeContext";
import { Icon } from "@circle-react-shared/Icon";

export interface StepperDotsProps {
  activeDot: number;
  className?: string;
  totalDots: number;
}

const DOT_ICONS = {
  active: {
    dark: "10-active-dot-dark-mode",
    light: "10-active-dot-light-mode",
  },
  inactive: {
    dark: "10-inactive-dot-dark-mode",
    light: "10-inactive-dot-light-mode",
  },
} as const;

const getIconType = (isActive: boolean, isDark: boolean) =>
  DOT_ICONS[isActive ? "active" : "inactive"][isDark ? "dark" : "light"];

export const StepperDots = ({
  totalDots,
  activeDot,
  className,
}: StepperDotsProps) => {
  const { isDarkAppearance = false } = useThemeContext();

  return (
    <div
      className={classNames(
        "flex items-center justify-center gap-2",
        className,
      )}
    >
      {Array.from({ length: totalDots }).map((_, index) => (
        <Icon
          key={`stepper-${totalDots - index}`}
          type={getIconType(activeDot === index, isDarkAppearance)}
          size={10}
        />
      ))}
    </div>
  );
};
